import React from "react";
import CampaignForm from "../../components/sponsor/CampaignForm";
import NavBar from "../../components/common/NavBar";
import { useNavigate } from "react-router-dom";
import useTranslation from "../../i18n/useTranslation";

export default function CreateCampaign() {
    const { t } = useTranslation();
    const scopeId = "kbola-create-campaign-page";
    const navigate = useNavigate();

    const navBarElem = {
        pageTitle: t('campaigns.newCampaign'),
        links: [
            { pageTitle: t('campaigns.advertising'), navLink: null, active: false },
            { pageTitle: t('campaigns.campaigns'), navLink: "/advertise/campaign", active: false },
            { pageTitle: t('campaigns.newCampaign'), navLink: null, active: true },
        ],
    };

    return (
        <div className="content-wrapper" id={scopeId}>
            <NavBar navBarElem={navBarElem} />

            <section className="content" style={{ padding: "0 10px 14px" }}>
                <CampaignForm mode="create" onSaved={() => navigate("/advertise/campaign")} />
            </section>

            {/* ✅ Page-scoped styling (matches your new light style pages) */}
            <style>{`
        #${scopeId}{
          font-family: 'Poppins', sans-serif;
        }

        /* Focus ring consistency for inputs/buttons inside CampaignForm */
        #${scopeId} .form-control:focus,
        #${scopeId} button:focus,
        #${scopeId} .btn:focus{
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(var(--kbs-primary-rgb, 0,173,255), 0.18);
          border-color: rgba(var(--kbs-primary-rgb, 0,173,255), 0.65);
        }

        /* FontAwesome safety (if CampaignForm uses icons) */
        #${scopeId} i.fas,
        #${scopeId} i.far,
        #${scopeId} i.fal,
        #${scopeId} i.fa,
        #${scopeId} i[class^="fa-"],
        #${scopeId} i[class*=" fa-"] {
          font-family: "Font Awesome 5 Free" !important;
          font-weight: 900;
        }
        #${scopeId} i.fab {
          font-family: "Font Awesome 5 Brands" !important;
          font-weight: 400;
        }
      `}</style>
        </div>
    );
}
